/**
 * Created by tmorone on 3/22/2016.
 */

var App = require('../app.js');
var Marionette = require('backbone.marionette');

/**
 * The quiz view. Uses a canvas driven by easeljs.
 */
module.exports = Marionette.CompositeView.extend({
    template: require('../templates/QuizBody.html'),
    modelEvents: {
        sync: 'attract'
    },

    initialize: function() {
        this.model.fetch();
    },

    attract: function() {
        this.render();
        var canvas = document.getElementById("quizCanvas");
        var stage = this.stage = new createjs.Stage(canvas);
        this.canvasWidth = canvas.width;
        this.canvasHeight = canvas.height;

        //var container = new createjs.Container();
        //this.stage.addChild(container);
        //
        //var title = new createjs.Text(this.model.get('title'), "30px arial", "#2f2f2f");
        //container.addChild(title);
        //
        //var prompt = new createjs.Text(this.model.get('prompt'), "30px arial", "#2f2f2f");
        //prompt.y = title.getBounds().height + 5;
        //container.addChild(prompt);
        //
        //var maxWidth = Math.max(title.getBounds().width, prompt.getBounds().width);
        //title.x = (maxWidth - title.getBounds().width) >> 1;
        //prompt.x = (maxWidth - prompt.getBounds().width) >> 1;
        //
        //container.x = (canvas.width - container.getBounds().width) >> 1;
        //container.y = (canvas.height - container.getBounds().height) >> 1;
        //
        //var hit = new createjs.Shape();
        //hit.graphics.beginFill("#000").drawRect(0,0,container.getBounds().width, container.getBounds().height);
        //container.hitArea = hit;
        //
        //// handlers
        //container.on("mouseover", this.handleHighlight);
        //container.on("mouseout", this.handleHighlight);
        //container.on("click", this.start.bind(this));

        stage.update();
        stage.enableMouseOver(10);
        createjs.Ticker.addEventListener("tick", stage);

        this.question = 0;
        this.points = [0,0];
        this.nextQuestion();
        //this.state = "waiting";
        //setTimeout(this.start.bind(this), 3000);
    },

    //start: function() {
    //    if(this.state == "waiting") {
    //        this.state = "started";
    //        this.nextQuestion();
    //    }
    //},

    nextQuestion: function() {
        if(this.model.get('questions').length <= this.question) {
            this.getResult();
            return;
        }

        // setup stage to display the question
        this.stage.removeAllChildren();
        var container = new createjs.Container();
        this.stage.addChild(container);

        // display the title
        var title = new createjs.Text(this.model.get('title'), "italic 20px arial", "#2f2f2f");
        title.x = (this.canvasWidth - title.getBounds().width) >> 1;
        title.y = 5;
        this.stage.addChild(title);

        // get the current question
        var q = this.model.get('questions')[this.question];

        // question text
        var text_q = new createjs.Text(q.question, "30px arial", "darkblue");
        container.addChild(text_q);

        // answers
        var i,maxWidth=text_q.getBounds().width;
        var cur_y = container.getBounds().height + 20;
        for(i=0; i < q.answers.length; i++) {
            var text_a = new createjs.Text(q.answers[i].answer, "28px arial", "darkolivegreen");
            text_a.y = cur_y;
            container.addChild(text_a);
            maxWidth = Math.max(maxWidth, text_a.getBounds().width);
            cur_y = container.getBounds().height + 10;

            // hit area for highlight
            var hit = new createjs.Shape();
            hit.graphics.beginFill("#000").drawRect(0,0,text_a.getMeasuredWidth(), text_a.getMeasuredHeight());
            text_a.hitArea = hit;

            text_a.points = q.answers[i].points;

            // handlers
            text_a.on("mouseover", this.handleHighlight);
            text_a.on("mouseout", this.handleHighlight);
            text_a.on("click", this.handleClick.bind(this));
        }

        for(i=0; i < container.numChildren; i++) {
            var obj = container.getChildAt(i);
            obj.x = (maxWidth - obj.getBounds().width) >> 1;
        }

        container.x = (this.canvasWidth - container.getBounds().width) >> 1;
        container.y = (this.canvasHeight - container.getBounds().height) >> 1;

        this.stage.update();
        this.question++;
    },

    getResult: function() {
        // setup stage to display the result
        this.stage.removeAllChildren();
        var container = new createjs.Container();
        this.stage.addChild(container);

        var title = new createjs.Text(this.model.get('title'), "italic 20px arial", "#2f2f2f");
        title.x = (this.canvasWidth - title.getBounds().width) >> 1;
        title.y = 5;
        this.stage.addChild(title);


        var minAnswers = [], minDistance = 1000, results = this.model.get('results');
        for(var i=0; i<results.length; i++){
            var d = 0;
            for(var j=0; j<this.points.length; j++){
                if(results[i].points) d += ((this.points[j] || 0) - (results[i].points[j] || 0)) * ((this.points[j] || 0) - (results[i].points[j] || 0));
            }
            if(!minAnswers.length || minDistance >= d){
                if(minDistance > d) minAnswers = [];
                minAnswers.push(results[i]);
                minDistance = d;
            }
        }
        var result = minAnswers[0];

        var text = new createjs.Text(result.name, "36px arial bold", "darkblue");
        text.outline = true;
        container.addChild(text);

        var maxHeight = container.getBounds().height + 15;
        var image = PR.asset_path + "/collection_quiz_images/" + result.slug + ".png";
        var bitmap = new createjs.Bitmap(image);
        bitmap.y = maxHeight;
        maxHeight += 256;
        container.addChild(bitmap);

        var maxWidth = Math.max(container.getBounds().width, 256);
        text.x = (maxWidth - text.getBounds().width) >> 1;
        bitmap.x = (maxWidth - 256) >> 1;

        container.x = (this.canvasWidth - maxWidth) >> 1;
        container.y = (this.canvasHeight - maxHeight) >> 1;

        this.stage.update();

        var button = document.getElementById("shareOnFb");
        button.style.visibility = "visible";
        button.addEventListener("click", function(){
            App.Logger.debug('button click');
            App.Events.trigger("fb:share", {
                name:result.name,
                ref:'quiz,quiz_'+this.model.id,
                description:this.model.get('title'),
                image:image,
                url: location.origin + '/quiz/' + this.model.id + '/' + result.slug,
                caption:this.model.get('prompt')});
        }.bind(this));

        setTimeout(this.promotion.bind(this), 3000);
    },

    promotion: function() {
        var container = new createjs.Container();
        this.stage.addChild(container);

        var text = new createjs.Text("Like the art? Try PackRat!", "22px arial", "darkblue");
        container.addChild(text);
        var subtext = new createjs.Text("www.playpackrat.com", "20px arial", "darkblue");
        container.addChild(subtext);
        subtext.x = (text.getBounds().width - subtext.getBounds().width) >> 1;
        subtext.y = text.getBounds().height;

        container.x = (this.canvasWidth - container.getBounds().width) >> 1;
        container.y = this.canvasHeight - container.getBounds().height - 20;

        // hit area for highlight
        var hit = new createjs.Shape();
        hit.graphics.beginFill("#000").drawRect(0,0,container.getBounds().width,container.getBounds().height);
        container.hitArea = hit;

        // handlers
        container.on("mouseover", this.handleHighlight);
        container.on("mouseout", this.handleHighlight);
        container.on("click", function(event) {window.location.assign("/?utm_source=organic?utm_medium=quiz");});

    },

    handleHighlight: function(event) {
        event.target.alpha = (event.type == "mouseover") ? 0.6 : 1.0;
    },

    handleClick: function(event) {
        this.points[0] += event.target.points[0];
        this.points[1] += event.target.points[1];
        this.nextQuestion();
    }
});
